/**
 * TextAreaField Module
 * Provides utility functions for textarea manipulation
 */

const TextAreaFieldModule = {
    /**
     * Inserts text at the end of a textarea, triggers input event, focuses, and positions cursor
     * @param textAreaId - The ID of the textarea element
     * @param textToInsert - The text to insert at the end
     */
    insertTextAndFocus(textAreaId: string, textToInsert: string): void {
        const textarea = document.getElementById(textAreaId) as HTMLTextAreaElement;
        if (!textarea) {
            console.warn(`Textarea with id "${textAreaId}" not found`);
            return;
        }

        // Insert text at the end
        textarea.value = textarea.value + textToInsert;

        // Trigger input event to notify Blazor of the change
        const inputEvent = new Event('input', { bubbles: true, cancelable: true });
        textarea.dispatchEvent(inputEvent);

        // Focus the textarea
        textarea.focus();

        // Set cursor position at the end
        const cursorPosition = textarea.value.length;
        textarea.setSelectionRange(cursorPosition, cursorPosition);
    }
};

export default TextAreaFieldModule;
